import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { configService } from '@kss/api';
import { useTheme, setConfig, applyBrandTheme } from '@kss/theme';

/**
 * Startup sync of the tenant config (`GET /api/ui/config`) for the customer web
 * app — stores brand/terminology/enabled-screens and snaps the industry accent
 * (only when the backend industry differs from the persisted one, preserving the
 * user's own theme/accent/language choices).
 */
export function ConfigBootstrap() {
  const dispatch = useDispatch();
  const { industry, setIndustry } = useTheme();

  useEffect(() => {
    let alive = true;
    configService
      .get()
      .then((cfg) => {
        if (!alive) return;
        dispatch(setConfig({ brand: cfg.brand, logo: cfg.logo, terminology: cfg.terminology, enabledScreens: cfg.enabledScreens, landing: cfg.landing }));
        // The <title> in index.html is static ("The Backyard — Order"); reflect the admin-set name.
        if (cfg.brand?.trim()) document.title = `${cfg.brand.trim()} — Order`;
        if (cfg.industry !== industry) setIndustry(cfg.industry);
        // Apply the admin-set dynamic theme (accent + deep colour + light/dark) over the default.
        applyBrandTheme({ accent: cfg.accent, secondary: cfg.secondary, mode: cfg.mode });
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
